import AiImages from './AiImages'

export default AiImages
